import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { TimeHlp } from 'src/lib/fliko/helpers/time.helper';
import { AppDateAdapter, AppDateTimeAdapter } from 'src/app/shared/classes/custom-date-adapter';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';
import { LegacyLabel } from '../common/legacy-label';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: NgxMatDateAdapter, useClass: AppDateTimeAdapter }
  ]
})
export class DateInputComponent extends LegacyLabel implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() placeholderKey: string | LocLabel | null | undefined;
  @Input() min: Date | null = null;
  @Input() max: Date | null = null;
  @Input() startAt: Date | null = null;
  @Input() outsideLabel = true;
  @Input() required = false;
  @Input() filteredDaysOfWeek: number[] = [];
  @Input() filteredDates: number[] = [];
  @Input() footer = true;
  @Input() hours = false;
  @Input() colors: ColorSchemes = ColorSchemes.PRIMARY;

  private _value: any;

  public filterDaysFunc = (d: Date | null): boolean => {
    const day = TimeHlp.dayOfWeek(d || Date.now());
    const validDayOfWeek = !this.filteredDaysOfWeek.includes(day);
    const validDate = !this.filteredDates.includes(d?.valueOf() ?? 0);
    return validDayOfWeek && validDate;
  };

  ColorSchemes = ColorSchemes;
  constructor(public ngControl: NgControl) {
    super();
    ngControl.valueAccessor = this;
  }

  // this method sets the value programmatically
  // tslint:disable-next-line:typedef
  public writeValue(value: any) {
    if (value !== this._value) {
      this._value = value;
    }
  }

  get calendarStartAt(): Date | null {
    if (!this.value) return this.startAt ?? this.min;
    if (this.min && this.value.valueOf() < this.min.valueOf()) return this.startAt ?? this.min;
    if (this.max && this.value.valueOf() > this.max.valueOf()) return this.max;
    return this.value;
  }

  get value(): Date {
    return this._value;
  }

  set value(value: Date | null) {
    // ? Remove seconds and milliseconds from date
    if (!value || (value instanceof Date && isNaN(value.getTime()))) {
      console.warn('Provide a date');
      value = null;
    } else {
      value = new Date(this.hours ? value.setSeconds(0) : TimeHlp.at(value, 0));
    }
    this.writeValue(value);
    this.onChange(value);
    this.onTouch();
  }

  // upon UI element value changes, this method gets triggered
  // tslint:disable-next-line:typedef
  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // upon touching the element, this method gets triggered
  // tslint:disable-next-line:typedef
  public registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  public onChange: any = (value: any) => {
    this.value = value;
  };
  public onTouch: any = () => {};
}
